const React = require("react");
const createReactClass = require("create-react-class");
const PT = require("prop-types");
const _ = require("lodash");
const HoverText = require("./HoverText");

const styles = require("./styles/HomeworkIcon.css");

module.exports = createReactClass({
	displayName: "HomeworkIcon",

	propTypes: {
		className: PT.string,
		disabled: PT.bool,
		disabledText: PT.string,
		hidden: PT.bool,
		onClick: PT.func,
		isAssigned: PT.bool,
		isUnreleased: PT.bool,
		colorStyle: PT.string,
		secondaryColorStyle: PT.string,
		size: PT.oneOf(["small", "large"]),
		forBlock: PT.object,
		sizeOverride: PT.string, // CSS class to override the size (in rem)
		isAcademy: PT.bool,
		noTooltip: PT.bool,
	},

	getInitialState: function() {
		return {
			isHovering: false,
		};
	},

	onHoverStart: function() {},

	onHoverEnd: function() {},

	onClick: function() {
		this.props.onClick && this.props.onClick();
	},

	getHWIconSvg: function(svgClass) {
		const {secondaryColorStyle} = this.props;
		const innerFill = secondaryColorStyle || styles.hwIconFill;
		const svg = (
			<svg
				className={svgClass}
				version={"1.1"}
				x={"0px"}
				y={"0px"}
				viewBox={"0 0 40 40"}
				width={"40"}
				height={"40"}
				preserveAspectRatio={"none"}
			>
				<g>
					<path d="M1,15.22c-2.46,9.56,3.7,20.68,13.87,22.88S36.55,33.46,39,23.9A17.38,17.38,0,0,0,25.67,2.37C15.5.17,3.44,5.66,1,15.22Z" />
					<path
						className={innerFill}
						d="M25.74,36c9.18-3.51,14-13.32,10.84-21.93S23.36,1.35,14.17,4.85.13,18.18,3.33,26.78,16.56,39.52,25.74,36ZM18.68,5C27.25,3.7,35.27,10.51,36.1,18.68S30.52,33.72,22,35s-17.19-3.62-18-11.78S10.12,6.34,18.68,5Z"
					/>
					<path
						className={innerFill}
						d="M7.57,16.06l-.11-1.53h4.32l.11,1.53-1.12.22v3.05H15V16.28l-1.12-.22V14.78h4.32v1.28l-1.12.22v7.59l1.12.22.11,1.76H14l-.11-1.76L15,23.87V21H10.77v2.91l1.12.22-.11,1.76H7.46l.11-1.76,1.11-.22V16.28Z"
					/>
					<path
						className={innerFill}
						d="M32.57,16.28l-.86.11-1.79,9.68H28l-2.24-7.47h0l-2.18,7.75H21.57l-1.86-10-.85-.11L19,14.75h3.84l-.11,1.53-1,.17,1.2,5.8h0l1.79-6.79h1.54l2.13,6.79h0l1.19-5.8-1-.17V14.75h3.83Z"
					/>
				</g>
			</svg>
		);

		return svg;
	},

	render: function() {
		const {
			isAssigned,
			size = "small",
			disabled,
			disabledText,
			sizeOverride,
			colorStyle,
			isAcademy,
			isUnreleased,
		} = this.props;
		let mainClass = disabled ? styles.mainDisabled : styles.main;

		let svgClass = null,
			hoverTextClass = null;

		if (sizeOverride) {
			svgClass += " " + sizeOverride;
			hoverTextClass = sizeOverride;
		} else {
			svgClass += " " + styles["svg" + _.capitalize(size)];
			hoverTextClass = " " + styles["hoverText" + _.capitalize(size)];
		}
		if (isAssigned && !colorStyle) {
			svgClass += " " + styles.assigned;
		} else if (colorStyle) {
			svgClass += " " + colorStyle;
		}

		if (isUnreleased) {
			svgClass += " " + styles.unreleased;
		}

		if (this.props.hidden) {
			mainClass +=
				" " + styles["svg" + _.capitalize(size)] + " " + styles.mainHidden;
		}

		if (isAcademy) {
			mainClass += " " + styles.academy;
		}

		if (this.props.className) {
			mainClass += " " + this.props.className;
		}

		const svg = this.getHWIconSvg(svgClass);

		const mainIcon = (
			<div
				className={mainClass}
				onClick={this.onClick}
				onMouseEnter={this.onHoverStart}
				onMouseLeave={this.onHoverEnd}
			>
				{svg}
			</div>
		);

		let elem = mainIcon;
		if (!this.props.noTooltip && this.props.forBlock) {
			const {displayName = "", blockID = 0} = this.props.forBlock;

			const academyHoverText =
				isAssigned && !isUnreleased ? "Assigned" : "Not yet available";
			const regularHoverText = isAssigned
				? `Click to Un-assign ${displayName}`
				: `Click to Assign ${displayName}`;
			let hoverText = isAcademy ? academyHoverText : regularHoverText;
			if (disabled && disabledText) {
				hoverText = disabledText;
			}

			elem = (
				<HoverText
					className={hoverTextClass}
					text={hoverText}
					key={`binderClip_${blockID}`}
					size={"large"}
					direction={"br"}
				>
					{mainIcon}
				</HoverText>
			);
		}

		return elem;
	},
});
